// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"ea01743c","138":"985380a2","370":"9b802c25","445":"dadcd689","805":"ae0cae2b"}[chunkId] + ".css";
};